module.exports = __webpack_public_path__ + "img/c_12.4002064f.png";